import React from 'react'
import ExperienceSection from '../components/ExperienceSection'
import ProjectsSection from '../components/ProjectsSection'
import AwardsSection from '../components/AwardsSection'
import About from '../components/Sidebar/About'
import Links from '../components/Sidebar/Links'

import './style.scss'

const IndexPage = () => (
  <div className="index">
    <div className="main">
      <h5>
        Hi, I'm <span className="bold">Mike Roelens</span>
      </h5>

      <h3 className="bold">
        Award-winning full stack developer with over 7 years experience. I've built
        products for major ecommerce retailers, my own startup, and many fun hacks!
        </h3>

      <ExperienceSection />
      <ProjectsSection />
      <div style={{ textAlign: 'center', color: '#656262', marginTop: '20px' }}>
      ...I've also initiated and built many internal tools/projects at companies, e.g.
        <ul style={{listStyle: 'none', marginTop: '5px'}}>
          <li><span className="bold">Chrome extension</span> to monitor pre-production environments</li>
          <li><span className="bold">Proxy tool</span> to help trace analytics calls sent from mobile devices</li>
          <li><span className="bold">Electron desktop app</span> to streamline support and admin tasks</li>
        </ul>
      </div>
      <AwardsSection />
    </div>

    <div className="aside">
      <div className="top">
        <About />
      </div>
      <div className="bottom">
        <Links />
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js